module.exports = __webpack_public_path__ + "img/step2.b5da1c97.png";